var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 800",
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.41421,
    style: {
      whiteSpace: "preserve-spaces"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Anarcute",
    width: 800,
    height: 800,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 400,
    ry: 400.019,
    fill: "#e76ea6",
    transform: "translate(0,0) translate(400,399.981)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Anarcute1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.404,752.255C270.676,690.634,373.766,639,476.253,639C556.292,639,623.996,655.233,674.55,690.818C602.888,758.502,506.255,800.019,400,800.019C331.417,800.018,266.843,782.721,210.404,752.255Z",
    fill: "#d8302d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.795,783.868C379.409,774.905,249.601,749.789,254.216,714.721C314.467,671.02,395.547,639,476.253,639C556.292,639,623.996,655.233,674.55,690.818C629.3,733.556,574.093,765.861,512.795,783.868Z",
    fill: "#cc2926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.253,639C538.668,639,593.581,648.871,638.712,670.093C663.579,681.786,551.651,739.634,488.648,748.155C382.866,762.461,243.488,721.497,267.004,705.832C325.675,666.746,401.126,639,476.253,639Z",
    fill: "#bb2523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.079,20.236C313.678,7.096,356.015,-0.019,400,-0.019C402.337,-0.019,404.669,0.001,406.997,0.042C431.736,123.546,422.924,229.095,386.99,236.47C350.691,243.92,300.374,148.389,274.696,23.272C274.488,22.259,274.282,21.247,274.079,20.236Z",
    fill: "#e3c8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.356,180.535C388.038,176.998,402.78,175.445,418.186,176.093C413.454,210.777,402.871,233.211,386.99,236.47C371.656,239.617,353.819,224.386,336.396,196.31C347.45,189.175,357.964,184.242,373.356,180.535Z",
    fill: "#dbbbce"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.702,0.199C401.995,88.396,393.614,161.491,366.37,167.082C338.741,172.753,301.597,106.966,281.081,17.984C314.616,7.542,350.039,1.398,386.702,0.199Z",
    fill: "#d8a6c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.505,14.34C557.458,28.4,604.347,52.297,644.999,83.857C618.34,206.104,565.011,297.753,524.927,289.34C484.242,280.8,472.51,172.382,498.747,47.38C501.114,36.101,503.71,25.07,506.505,14.34Z",
    fill: "#e3c8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.269,206.414C554.937,218.467,570.052,236.927,578.284,253.838C560.109,279.356,541.4,292.797,524.927,289.34C500.029,284.114,485.974,241.482,484.829,180.535C502.736,184.974,522.479,194.996,538.269,206.414Z",
    fill: "#d3aec4",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.093,19.635C566.174,33.372,605.195,53.904,639.857,79.932C619.091,150.699,585.497,199.055,557.077,193.898C523.86,187.87,509.712,110.92,524.093,19.635Z",
    fill: "#d8a6c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.168,182.884C471.71,183.596,516.054,196.766,570.236,290.677C615.519,369.166,635.616,462.236,637.85,534.077C641.805,661.254,538.512,721.057,407.891,723.59C277.271,726.123,205.646,670.489,198.405,581.182C191.164,491.874,209.841,387.71,261.086,294.212C309.668,205.571,373.75,181.918,430.168,182.884Z",
    fill: "#edd9e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.405,581.182C283.008,665.728,445.211,670.554,531.557,588.245C598.777,524.168,568.666,327.602,531.768,234.822C544.061,249.198,556.848,267.472,570.236,290.677C615.519,369.166,635.616,462.236,637.85,534.077C641.805,661.254,538.512,721.057,407.891,723.59C277.271,726.123,205.646,670.489,198.405,581.182Z",
    fill: "#e3c8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.204,681.039C232.076,667.223,280.257,693.863,345.001,705.265C394.946,714.061,475.95,707.06,522.175,683.745C602.472,643.244,632.549,596.143,620.278,620.409C585.753,688.68,504.259,721.721,407.891,723.59C337.662,724.952,284.487,709.499,249.204,681.039Z",
    fill: "#d0aec3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.657,451.711C256.824,512.699,227.656,567.116,211.655,563.716C195.423,560.266,163.721,512.109,177.653,441.71C193.703,360.607,242.611,319.039,258.657,322.704C273.107,326.005,279.267,386.352,267.657,451.711Z",
    fill: "#8c47bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,443.167C448.86,369.956,464.375,319.125,497,314C529.625,308.875,577.125,362.125,590,425C604.483,495.726,582.125,546.625,546,553C516.788,558.155,464.712,532.492,456,443.167Z",
    fill: "#8c47bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.68,570.457C359.948,561.085,358.664,524.309,358.664,524.309C358.664,524.309,336.464,521.485,321.313,519.531C313.72,518.552,309.445,513.383,311.854,506.267C314.01,499.902,320.169,496.643,328.551,501.548C339.808,508.134,359.555,519.595,359.555,519.595C359.555,519.595,373.438,512.05,387.192,504.154C395.797,499.214,403.427,501.009,405.762,506.588C407.885,511.659,405.061,519.764,394.695,520.849C377.51,522.65,368.868,523.572,360.179,524.404C362.44,534.595,367.761,556.122,371.614,570.896C372.535,574.426,361.073,575.493,360.68,570.457Z",
    fill: "#f47685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.603,453.265C495.002,413.307,497.827,370.253,513.492,366.281C527.356,362.766,548.529,390.064,559.502,430.171C567.79,460.461,570.15,509.496,546.554,512.588C522.959,515.681,509.322,488.585,502.603,453.265Z",
    fill: "#372bad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,453.265C247.654,423.493,253.4,377.7,240,375C226.6,372.3,209.034,418.946,203,441C195.219,469.439,192.9,507.562,211,507.713C229.1,507.864,238.023,474.209,242,453.265Z",
    fill: "#372bad"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M515.097,338.214C526.926,334.212,541.054,344.34,546.627,360.815C552.201,377.29,547.122,393.915,535.293,397.917C523.464,401.918,509.335,391.791,503.762,375.316C498.189,358.84,503.267,342.216,515.097,338.214Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.13,394.487C550.196,391.416,555.401,391.441,557.744,394.544C560.088,397.646,558.689,402.659,554.623,405.731C550.556,408.802,545.352,408.777,543.008,405.674C540.665,402.572,542.064,397.559,546.13,394.487Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.79,408.078C559.088,407.664,562.029,409.434,562.355,412.027C562.68,414.621,560.268,417.063,556.97,417.477C553.673,417.891,550.731,416.121,550.406,413.527C550.08,410.934,552.493,408.492,555.79,408.078Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.359,399.373C517.266,402.403,517.838,406.579,515.636,408.691C513.434,410.803,509.286,410.058,506.379,407.027C503.472,403.997,502.899,399.821,505.102,397.709C507.304,395.597,511.452,396.342,514.359,399.373Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M240.388,339.883C237.8,335.105,231.07,343.854,225.368,359.408C219.667,374.963,217.139,391.47,219.727,396.247C222.315,401.025,229.046,392.276,234.747,376.722C240.449,361.168,242.976,344.661,240.388,339.883Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.256,394.737C217.449,391.515,215.845,391.306,214.676,394.271C213.507,397.236,213.213,402.259,214.02,405.481C214.827,408.703,216.431,408.912,217.6,405.947C218.769,402.982,219.063,397.959,218.256,394.737Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.757,408.078C211.733,407.664,210.819,409.434,210.717,412.027C210.616,414.621,211.366,417.063,212.391,417.477C213.416,417.891,214.33,416.121,214.431,413.527C214.532,410.934,213.782,408.492,212.757,408.078Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.111,397.521C237.207,400.551,237.03,404.727,237.714,406.839C238.398,408.951,239.688,408.206,240.591,405.175C241.494,402.145,241.672,397.969,240.988,395.857C240.303,393.745,239.014,394.49,238.111,397.521Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.664,563.703C200.926,559.361,176.166,513.528,190.258,448.586C206.623,373.173,249.531,335.77,263.023,339.692C268.742,341.355,272.475,354.793,273.527,374.901C274.327,396.881,272.608,423.84,267.657,451.711C257.472,509.05,231.08,560.581,214.664,563.703Z",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.944,546.3C488.91,534.13,467.049,505.653,461.881,452.667C455.355,385.754,469.536,339.295,499.355,334.611C529.174,329.926,572.588,378.596,584.356,436.063C597.593,500.706,577.158,547.227,544.14,553.054C541.962,553.439,539.644,553.635,537.188,553.607C529.113,553.379,520.037,551.109,510.944,546.3Z",
    fill: "#fff",
    fillOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar1);
export default __webpack_public_path__ + "static/media/avatar_1.f74e999179e7d5b2ced477a315d42857.svg";
export { ForwardRef as ReactComponent };